(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    if (root.dataset.srInit === '1') return;
    root.dataset.srInit = '1';

    var track = root.querySelector('[data-track]');
    var btns = root.querySelectorAll('.shop-reviews__nav');
    var thumb = root.querySelector('[data-progress-thumb]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.shop-reviews__card');
      if (!card) return track.clientWidth * 0.8;
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0', 10) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function updateButtons() {
      var max = maxScroll() - 1;
      btns.forEach(function (btn) {
        if (btn.dataset.dir === 'prev') {
          btn.disabled = track.scrollLeft <= 1;
        } else {
          btn.disabled = track.scrollLeft >= max;
        }
      });
    }

    // Thumb laeuft mit; bewegt sich ueber die verbleibenden 60% der Track-Breite
    function updateProgress() {
      if (!thumb) return;
      var max = maxScroll();
      var ratio = max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0;
      thumb.style.transform = 'translateX(' + (ratio * 150) + '%)';
    }

    function refresh() {
      updateButtons();
      updateProgress();
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.dataset.dir === 'prev' ? -1 : 1;
        track.scrollBy({ left: step() * dir, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(refresh);
    }, { passive: true });

    refresh();
  }

  function initAll() {
    document.querySelectorAll('[data-shop-reviews]').forEach(initCarousel);
  }

  // Fallback-Modus: nur einblenden, wenn das Produkt keine Judge.me-Bewertungen hat.
  document.addEventListener('lora:reviews:loaded', function (e) {
    var hasReviews = e.detail && e.detail.hasReviews;
    document.querySelectorAll('.shop-reviews[data-review-fallback]').forEach(function (el) {
      el.hidden = !!hasReviews;
      if (!hasReviews) {
        var carousel = el.querySelector('[data-shop-reviews]');
        if (carousel) initCarousel(carousel);
        var track = el.querySelector('[data-track]');
        if (track) track.dispatchEvent(new Event('scroll'));
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme-Editor: Section neu laden
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-shop-reviews]').forEach(function (el) {
      el.dataset.srInit = '';
      initCarousel(el);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
